import { ColDef } from 'ag-grid-community';
import { BtnDefault } from '../common/Buttons';
import MismatchStatus from '../MismatchStatus';
import { IAgent } from '../../types/agent';
import { IRaiseMismatch } from '../../api/queries';

const MismatchActionsCell: React.FC<{
  data: IRaiseMismatch;
  onView: (data: IRaiseMismatch) => void;
}> = ({ data, onView }) => {
  return (
    <div className="flex gap-2 p-1">
      <BtnDefault onClick={() => onView(data)}>View</BtnDefault>
    </div>
  );
};

export const useMismatchCol = ({
  onView,
  agents,
}: {
  onView: (data: IRaiseMismatch) => void;
  agents?: IAgent[];
}): ColDef[] => {
  return [
    ...mismatchRequestColumnsDefs,
    {
      headerName: 'Agent',
      field: 'kimId',
      minWidth: 100,
      width: 100,
      suppressSizeToFit: true,
      valueGetter: (params) => {
        const agent = agents?.find(
          (a: IAgent) => a.kimId === params.data?.kimId
        );
        return agent?.name ?? '-';
      },
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      filter: false,
      minWidth: 100,
      width: 100,
      suppressSizeToFit: true,
      pinned: 'right',
      lockPinned: true,
      cellRenderer: (params: any) => (
        <div className="flex gap-2 p-1">
          <MismatchActionsCell data={params.data} onView={onView} />
        </div>
      ),
    },
  ];
};

const mismatchRequestColumnsDefs: ColDef<IRaiseMismatch>[] = [
  {
    field: '_id',
    headerName: 'Request ID',
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'logId',
    headerName: 'Log ID',
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'kimId',
    headerName: 'Kim ID',
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    cellRenderer: (params: any) => {
      return <MismatchStatus status={params.value} />;
    },
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'category',
    headerName: 'Category',
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'account',
    headerName: 'Account',
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'comment',
    headerName: 'Comment',
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'startTime',
    headerName: 'Start Time',
    sortable: true,
    valueGetter: (params: any) => {
      return new Date(params.data.startTime);
    },
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'stopTime',
    headerName: 'Stop Time',
    sortable: true,
    valueGetter: (params: any) => {
      return new Date(params.data.stopTime);
    },
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    valueGetter: (params: any) => {
      return new Date(params.data.createdAt);
    },
    sortable: true,
    filter: true,
    minWidth: 120,
    suppressSizeToFit: true,
  },
];
